module.exports = __webpack_public_path__ + "static/portfolio_gallery_11-0073a75539dd702d7bdf16de02e345c9.jpg";